import React from 'react';
import CollapseValidation from './CollapseValidation';
import TooltipValidation from './TooltipValidation';
import Validation from './Validation';
import { validationDisplayTypes } from './constants';
export const resolveValidation = ({ validationDisplayType: validationDisplayTypeInput = validationDisplayTypes.COLLAPSE_TEXT, ...props })=>{
    if (validationDisplayTypeInput === validationDisplayTypes.COLLAPSE_TEXT) {
        return props.validationText !== null && !props.hideValidationText && /*#__PURE__*/ React.createElement(CollapseValidation, props);
    }
    if (validationDisplayTypeInput === validationDisplayTypes.PLAIN_TEXT) {
        return props.validationText && /*#__PURE__*/ React.createElement(Validation, props);
    }
    if (validationDisplayTypeInput === validationDisplayTypes.TOOLTIP) {
        return props.validationText && /*#__PURE__*/ React.createElement(TooltipValidation, props);
    }
};
export default Validation;
